import React, { useState, useEffect } from 'react';
import {Redirect, useLocation, useHistory, Link} from 'react-router-dom';


import { Auth, API, graphqlOperation } from 'aws-amplify';
import MeetupsThumb01 from "../../images/meetups-thumb-01.jpg";
import UserImage01 from "../../images/avatar-01.jpg";
import UserImage04 from "../../images/avatar-04.jpg";
import UserImage05 from "../../images/avatar-05.jpg";
import CallToActionCard from "../ctas/CallToActionCard";


function IdeateCards({ideas, viewIdea}) {

  let history = useHistory();
  const location = useLocation()
  const search = location.search;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [authSession, setAuthSession] = useState(null)
  const [alertModalState, setAlertModalState] = useState(null)
  const [contentState, setContentState] = useState(null)
  const [emulatorData, setEmulatorData] = useState({})
  const [ authToken, setAuthToken ] = useState(null)
  const [ctaModalState, setCTAModalState] = useState(null)

  const [userDetails, setUserDetails] = useState({email: 'friend', client: { adminId: ''}})

  const [ideaCards, setIdeaCards] = useState('')

  useEffect(() => {
    if(ideas.length>0)
      setIdeaCards(ideas.map((item) => {
      return (
          item!=null?<article className="flex bg-white shadow-1 rounded-sm border border-slate-200 overflow-hidden"
                              onClick={(e)=> {
                                e.stopPropagation()
                                viewIdea(item)
                              }}>
            {/* Image */}
            <div className="relative flex-none w-56 cursor-pointer" onClick={(e)=> {
              e.stopPropagation()
              viewIdea(item)
            }}>
              <img
                  className="absolute object-cover object-center w-full h-full cursor-pointer"
                  src={item.image_url}
                  width="220"
                  height="236"
                  alt="Meetup 01"
              />
            </div>
            {/* Content */}
            <div className="grow p-5 flex flex-col cursor-pointer" onClick={(e)=> {
              e.stopPropagation()
              viewIdea(item)
            }}>
              <div className="grow">
                <div className="text-sm font-semibold text-indigo-500 uppercase mb-2">Mon 27 Dec, 2021</div>
                <div className="inline-flex mb-2">
                  <h3 className="text-lg font-bold text-slate-800 line-clamp-1 cursor-pointer" onClick={(e)=> {
                    e.stopPropagation()
                    viewIdea(item)
                  }}>
                    {item.email.includes('Body:')?item.email.split('Body:')[0].replace('Subject:', ''):''}
                  </h3>
                </div>
                <div className="text-sm line-clamp-3">
                  {item.email.includes('Body:')?item.email.split('Body:')[1]:''}
                </div>
              </div>
              {/* Footer */}
              <div className="flex justify-between mt-3">
                {/* Tag */}
                <div className="text-xs inline-flex items-center font-medium bg-slate-100 text-slate-600 rounded-full text-center px-2.5 py-1">
                  <svg className="w-4 h-3 fill-slate-400 mr-2" viewBox="0 0 16 12">
                    <path d="m16 2-4 2.4V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.6l4 2.4V2ZM2 10V2h8v8H2Z" />
                  </svg>
                  <span>Online Event</span>
                </div>
                {/* Avatars */}
                <div className="flex items-center space-x-2">
                  <div className="flex -space-x-3 -ml-0.5">
                    <img
                        className="rounded-full border-2 border-white box-content"
                        src={UserImage01}
                        width="28"
                        height="28"
                        alt="User 01"
                    />
                    <img
                        className="rounded-full border-2 border-white box-content"
                        src={UserImage04}
                        width="28"
                        height="28"
                        alt="User 04"
                    />
                    <img
                        className="rounded-full border-2 border-white box-content"
                        src={UserImage05}
                        width="28"
                        height="28"
                        alt="User 05"
                    />
                  </div>
                  <div className="text-xs font-medium text-slate-400 italic">+22</div>
                </div>
              </div>
            </div>
          </article>:''
      );
    }))
  }, [ideas]);

  function updateContentState(newState){
    setContentState(newState)
  }

  function OnLoad() {

    Auth.currentSession().then(response => {
      if(location!=null) {
        if(location.state==null) {
          history.push('/signin')
        }
        else{
          setUserDetails(location.state.userDetails)
        }
      }
      else {
        history.push('/signin')
      }
      setAuthSession(response)
      userHasAuthenticated(true);
      setIsAuthenticating(false);

    }).catch( (error) => {
      history.push('/signin')
    });
  }

  return (
      <div className="grid xl:grid-cols-2 gap-6">

        {/* Item 1 */}
        {ideaCards}

      </div>
  );
}

export default IdeateCards;